import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { PlusOrange } from "../../../../ui/icons/plusOrange";
import { TrashIcon } from "../../../../ui/icons/trash";
import { Calendar } from "../../../../ui/molecules/calendar";
import MultiSelectCheckbox from "../../../../ui/molecules/multiSelectCheckbox";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import { RowActivityMultiSelect, attivita_bio, categorie_prodotti } from "../../../../utils";
import { setRowsActivityBio, setUpdateRowsActivityBio } from "../slice";

interface Props {
    editRows?: boolean;
}

export function RowActivity(props: Props) {
    const dispatch = useAppDispatch();
    const functionsState = useAppSelector((state) => state.PMFunctions);

    const [rows, setRows] = useState<RowActivityMultiSelect[]>([
        { bioActivity: "", bioCategories: [], startingActivity: "", endingActivity: "" },
    ]);

    useEffect(() => {
        if (functionsState.functionUpdateRequest.functionActivities) {
            const activities = functionsState.functionUpdateRequest.functionActivities as any as RowActivityMultiSelect[];
            setRows([...activities]);
            dispatch(setUpdateRowsActivityBio(activities));
        }
    }, [functionsState.functionUpdateRequest.functionActivities]);

    const addRow = () => {
        setRows([...rows, { bioActivity: "", bioCategories: [], startingActivity: "", endingActivity: "" }]);
    };

    const removeRow = (index: number) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
        if (props.editRows) {
            dispatch(setUpdateRowsActivityBio(updatedRows));
        } else {
            dispatch(setRowsActivityBio(updatedRows));
        }
    };

    const handleChange = (
        index: number,
        field: keyof RowActivityMultiSelect,
        value: string | { label: string; value: string }[]
    ) => {
        const updatedRows = rows.map((row, rowIndex) => {
            if (rowIndex === index) {
                return { ...row, [field]: value };
            }
            return row;
        });

        setRows(updatedRows);

        const rowsToDispatch = updatedRows.map((row) => ({
            ...row,
            bioCategories: row.bioCategories?.map((category) => category),
        }));

        if (props.editRows) {
            dispatch(setUpdateRowsActivityBio(rowsToDispatch));
        } else {
            dispatch(setRowsActivityBio(rowsToDispatch));
        }
    };

    return (
        <Fragment>
            <div className="flex items-center justify-between">
                <p className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                    Attività
                </p>
                <button
                    className="text-[#FF941A] flex items-center gap-2 text-sm font-semibold"
                    onClick={addRow}
                >
                    Aggiungi attività <PlusOrange color={"#FF941A"} size={20} />
                </button>
            </div>

            {rows.map((row, index) => (
                <Fragment key={`activity-row-${index}`}>
                    <div className="mt-4 rounded-xl border border-neutral-200 bg-white p-4 flex flex-col gap-4">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                            <MadfarmStaticSelect
                                menuPortalTargetIsNotBody
                                label="Attività"
                                placeholder="Seleziona attività..."
                                options={attivita_bio}
                                defaultValue={row.bioActivity}
                                value={row.bioActivity}
                                onChange={(e) => {
                                    if (e) {
                                        //@ts-ignore
                                        const newValue = e.value ? e.value : null;
                                        handleChange(index, "bioActivity", newValue);
                                    }
                                }}
                                noOptionsMessage={""}
                            />
                            <Calendar
                                label="Data Inizio"
                                selected={row.startingActivity ? new Date(row.startingActivity) : null}
                                onChange={(date) => {
                                    handleChange(index, "startingActivity", format(new Date(date), "yyyy-MM-dd"));
                                }}
                            />
                            <Calendar
                                label="Data Fine"
                                selected={row.endingActivity ? new Date(row.endingActivity) : null}
                                onChange={(date) => {
                                    handleChange(index, "endingActivity", format(new Date(date), "yyyy-MM-dd"));
                                }}
                            />
                        </div>

                        <div className="grid grid-cols-1 gap-4">
                            <MultiSelectCheckbox
                                label="Categorie"
                                onChange={(e) => {
                                    handleChange(index, "bioCategories", e.value);
                                }}
                                value={row.bioCategories!}
                                option={categorie_prodotti}
                                placeholder="Categoria prodotti"
                                selectAllLabel="Tutte"
                            />
                        </div>

                        <div className="flex justify-end">
                            <button
                                className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                onClick={() => removeRow(index)}
                            >
                                <TrashIcon color="#8383AD" size={20} />
                            </button>
                        </div>
                    </div>
                </Fragment>
            ))}
        </Fragment>
    );
}